import { MdAdd, MdSwapHoriz } from 'react-icons/md'

interface ReplaceOrAppendDialogProps {
    /** Nome do item já escolhido no atendimento. */
    currentItemName?: string
    /** Nome do item que o operador acabou de escolher. */
    incomingItemName: string
    onCancel: () => void
    onAppend: () => void
    onReplace: () => void
}

/**
 * Escolher um segundo procedimento é ambíguo: trocar o que está lá ou empilhar?
 *
 * Perguntar é o que evita as duas leituras erradas — substituir em silêncio
 * perde o item anterior, e empilhar em silêncio dobra o valor sem aviso. Ver a
 * nota em `handleCatalogSelect`.
 */
export default function ReplaceOrAppendDialog({
    currentItemName,
    incomingItemName,
    onCancel,
    onAppend,
    onReplace,
}: ReplaceOrAppendDialogProps) {
    return (
        <dialog className="modal modal-open z-50">
            <div className="modal-box max-w-lg">
                <h3 className="text-lg font-bold">
                    Substituir ou adicionar à lista?
                </h3>
                <p className="mt-3 text-sm text-base-content/70">
                    Este atendimento tem <strong>{currentItemName}</strong> e
                    você escolheu <strong>{incomingItemName}</strong>.
                </p>
                <p className="mt-2 text-sm text-base-content/70">
                    <strong>Substituir</strong> troca o procedimento e mantém o
                    resto do atendimento como está. <strong>Adicionar</strong>{' '}
                    deixa os dois na conta, e o valor passa a somar os dois.
                </p>

                <div className="modal-action mt-6 flex-wrap justify-end gap-2">
                    <button
                        type="button"
                        className="btn btn-ghost"
                        onClick={onCancel}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline gap-2"
                        onClick={onAppend}
                    >
                        <MdAdd className="text-base" />
                        Adicionar à lista
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary gap-2"
                        onClick={onReplace}
                    >
                        <MdSwapHoriz className="text-base" />
                        Substituir
                    </button>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button" onClick={onCancel}>
                    fechar
                </button>
            </form>
        </dialog>
    )
}
